import { CompanyAccountModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const nullDto: CompanyAccountModelDto = {
    id: 0,
    number: '',
    type: '',
    name: '',
    cifNumber: '',
    status: '',
    accountUniqueId: '',
};

export class DepositAccount extends DomainEntity<CompanyAccountModelDto> {
    constructor(dto = nullDto) {
        super(dto);
    }

    public createDefault(): this {
        return new DepositAccount() as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get accountName() {
        return this.dto.name;
    }

    public get accountNumber() {
        return this.dto.number;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public get accountType() {
        return this.dto.type;
    }
}
